'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { trackWebVitals } from '@sbt-web/tracking';
import { getOrCreatePulse } from '@/tools/tracking/utils';
export default function WebVitals() {
  useReportWebVitals(_temp);
}
function _temp(metric) {
  const pulseInstance = getOrCreatePulse();
  if (pulseInstance !== undefined) {
    trackWebVitals(pulseInstance, metric);
  }
}